// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ProductionCenterDashboard.css */

/* --- Variables --- */
:root {
  --spacing-gap: 24px;
  --bg-color: #f0faeb;
}

/* --- Main Container --- */
.prod-dashboard-container {
  padding: 16px;
  background-color: var(--bg-color);
  min-height: 100vh;
}

@media (min-width: 900px) {
  .prod-dashboard-container {
    padding: 32px;
  }
}

/* --- Common Row Styles --- */
.dashboard-row {
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-gap);
  margin-bottom: var(--spacing-gap);
  width: 100%;
}

/* --- Card Logic --- */

/* Mobile: Full width (1 per row) */
.card-chart {
  width: 100%;
}

/* Tablet & Desktop: 2 per row (50% width minus gap) */
@media (min-width: 900px) {
  .card-chart {
    width: calc(50% - (var(--spacing-gap) / 2));
  }
}

/* Ensure paper inside cards takes full height of the grid cell */
.card-chart > .MuiPaper-root {
  height: 100%;
  display: flex;
  flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/Components/Dashboard/ProductionCenterDashboard.css"],"names":[],"mappings":"AAAA,kCAAkC;;AAElC,sBAAsB;AACtB;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,iCAAiC;EACjC,WAAW;AACb;;AAEA,uBAAuB;;AAEvB,mCAAmC;AACnC;EACE,WAAW;AACb;;AAEA,sDAAsD;AACtD;EACE;IACE,2CAA2C;EAC7C;AACF;;AAEA,iEAAiE;AACjE;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB","sourcesContent":["/* ProductionCenterDashboard.css */\n\n/* --- Variables --- */\n:root {\n  --spacing-gap: 24px;\n  --bg-color: #f0faeb;\n}\n\n/* --- Main Container --- */\n.prod-dashboard-container {\n  padding: 16px;\n  background-color: var(--bg-color);\n  min-height: 100vh;\n}\n\n@media (min-width: 900px) {\n  .prod-dashboard-container {\n    padding: 32px;\n  }\n}\n\n/* --- Common Row Styles --- */\n.dashboard-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--spacing-gap);\n  margin-bottom: var(--spacing-gap);\n  width: 100%;\n}\n\n/* --- Card Logic --- */\n\n/* Mobile: Full width (1 per row) */\n.card-chart {\n  width: 100%;\n}\n\n/* Tablet & Desktop: 2 per row (50% width minus gap) */\n@media (min-width: 900px) {\n  .card-chart {\n    width: calc(50% - (var(--spacing-gap) / 2));\n  }\n}\n\n/* Ensure paper inside cards takes full height of the grid cell */\n.card-chart > .MuiPaper-root {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
